var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M29.3346 14.7725V15.9992C29.333 18.8744 28.402 21.6721 26.6804 23.9749C24.9589 26.2778 22.539 27.9625 19.7818 28.7777C17.0245 29.5929 14.0776 29.495 11.3806 28.4986C8.68354 27.5022 6.38084 25.6606 4.81592 23.2486C3.25099 20.8365 2.50769 17.9833 2.69687 15.1143C2.88605 12.2453 3.99758 9.51427 5.86568 7.3286C7.73377 5.14293 10.2583 3.61968 13.0629 2.98603C15.8674 2.35238 18.8017 2.64228 21.428 3.8125M29.3346 5.3325L16.0013 18.6792L12.0013 14.6792",
    stroke: "#039855",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSvg);
export default __webpack_public_path__ + "static/media/CheckCircleSvg.7402afdc14f585fb955245ff0b8ab98b.svg";
export { ForwardRef as ReactComponent };